//import config from "config";
import types from './Types';

export const submitRequest = () => ({
    type: types.SUBMIT_REQUEST
});

export const completeRequest = () => ({
    type: types.COMPLETE_REQUEST
});

export const setUserLocation = location => ({
    type: types.SET_USER_LOCATION,
    uLat: location.uLat,
    uLng: location.uLng
});

export const errorEncountered = (error, location) => ({
    type: types.ERROR_ENCOUNTERED,
    error: error,
    location: location
});

// stores "store" details in redux
export const addStoreDetails = details => ({
    type: types.ADD_STORE_DETAILS,
    store: details
});

export const setSelectedStore = id => ({
    type: types.SET_SELECTED_STORE,
    id: id
});

// posts mystore id to the commerce cloud
export const postMyStore = (
    url,
    id,
    isNoLog,
    isAppointment,
    isDialog,
    redirectURL,
    isMyStore = true,
    additionalParams
) => (dispatch, getState) => {
    const currentState = getState();
    const product = currentState.globalState.product;
    let defaultBody = {
        storeId: id,
        isAppointment: isAppointment,
        isMyStore: isMyStore,
        locationID: additionalParams && additionalParams.locationID || false,
        timezoneID: additionalParams && additionalParams.timezoneID || false,
        services: additionalParams && additionalParams.services || {}
    };
    if (product && product.product && product.product.products) {
        defaultBody.products = product.product.products.map(e => {
            return {
                [e.name]: e.value
            };
        });
    }
    if (currentState.globalState.myStore === id) {
        return true;
    }
    if (additionalParams && additionalParams.employeeId) {
        defaultBody.employeeId = additionalParams.employeeId;
    }

    dispatch(submitRequest());
    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin', //must have to send cookies
        body: JSON.stringify(defaultBody)
    })
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        })
        .then(json => {
            dispatch(setMyStore(json, isNoLog, isAppointment, isDialog, redirectURL));
            if (json && json.product) {
                dispatch(setProduct(json.product));
            }
        })
        .catch(error => dispatch(errorEncountered(error.message, 'postMyStore')));
};
